import compose from 'recompose/compose';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import CompanyAddress from './CompanyAddress';

export default compose(
  connect(
    (state) => ({
      data: _get(state, 'customers.customerDetail.data.address', {}),
    }),
    {}
  )
)(CompanyAddress);
